<template>
    <span>
        <template v-if="label">{{ label }}</template>

        <template v-if="label && !isNaN(progress)"> - </template>

        <AnimatedNumber :delay="countDelay" :duration="countDuration" :number="progress" />%
    </span>
</template>

<script>
import AnimatedNumber from '@/Components/Utilities/AnimatedNumber';

export default {
    components: {
        AnimatedNumber
    },
    props: {
        label: String,
        progress: Number,
        countDuration: Number,
        countDelay: Number
    }
}
</script>

<style scoped>

</style>
